<template>
  <div class="quote-block">
    <div v-if="!!$slots['header']" class="header row">
      <slot name="header" />
    </div>
    <ul v-if="!!$slots['body']">
      <slot name="body" />
    </ul>
    <p v-else>{{ emptyResultLabel }}</p>
    <slot name="footer" />
  </div>
</template>

<script>
export default {
  props: {
    emptyResultLabel: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.quote-block {
  margin-bottom: 1em;
}

:deep() {
  .row {
    border-bottom: 1px solid #dae2e5;
    padding: 0.5rem;
    grid-column-gap: 0.5rem;
    display: grid;
  }

  .price {
    display: block;
    text-align: right;
  }

  .total {
    font-weight: $font-weight-bold;
    font-size: 1.2em;
    border-top: 1px solid #dae2e5;
    border-bottom: 2px solid #dae2e5;
  }

  .header {
    background-color: #f1f4f5;
    font-weight: $font-weight-bold;
  }

  h5 {
    margin-bottom: 0;
  }

  ul {
    list-style: none outside;
  }

  .title {
    grid-area: title;
  }

  .code {
    grid-area: code;
  }

  .vat {
    grid-area: vat;
  }

  .price-incl {
    grid-area: price-incl;
  }

  .price-excl {
    grid-area: price-excl;
  }
  .buttons {
    grid-area: buttons;
    text-align: right;
  }
}
</style>
